import { useState, useRef } from 'react';
import { SearchBox } from '@fluentui/react';
import { IProjects } from '../../../mobileTypes';
import { useMobileContext } from '../../../MobileContext';
import { useMobile } from '../../../useMobile';
import { useUiContext } from '../../../../components/Contexts/UIContext/uiCtx';
import { useMutation } from '@tanstack/react-query';
import { ApiCalls } from '../../../../api/api';
import { TimeSearchRow } from '../../../../api/generated/data-contracts';

interface IProps {
    shownProjects: IProjects[];
    setShownProjects: React.Dispatch<React.SetStateAction<IProjects[]>>;
    isDefaultProjects: boolean;
    setIsDefaultProjects: React.Dispatch<React.SetStateAction<boolean>>;
}

export const Search: React.FC<IProps> = props => {
    const mobCtx = useMobileContext();
    const { isDarkmode, isTeams } = useUiContext();

    const [inputValue, setInputValue] = useState('');

    const searchInProgress = useRef(false);
    const lastSearchQuery = useRef('');
    const parkedSearch = useRef<() => void | undefined>();

    const onSearch = () => {
        if (inputValue === '') {
            if (!props.isDefaultProjects) {
                props.setIsDefaultProjects(true);
            }
            props.setShownProjects(mobCtx.allProjects);
        } else {
            if (props.isDefaultProjects) {
                props.setIsDefaultProjects(false);
            }
            useMobile.getState().setIsloading({ active: true, overlay: true });
            search(inputValue);
        }
    };

    const { mutateAsync: searchEndpoint } = useMutation((query: string) => ApiCalls.searchTasks({ query }).then(res => res.data));

    const search = (query: string): void => {
        if (!searchInProgress.current) {
            searchInProgress.current = true;
            lastSearchQuery.current = query;

            searchEndpoint(query).then(json => {
                const localmetadata1values: string[] = [];
                json.forEach(time => {
                    if (!localmetadata1values.includes(time.metadata1)) {
                        localmetadata1values.push(time.metadata1);
                    }
                });

                const groupedTasks = groupByProject(json);
                console.log('groupedTasks: ', groupedTasks);
                console.log('mobCtx projects: ', props.shownProjects);
                searchInProgress.current = false;
                if (parkedSearch.current) {
                    const parked = parkedSearch.current;
                    parked();
                    parkedSearch.current = undefined;
                } else {
                    props.setShownProjects(groupedTasks);
                    useMobile.getState().setIsloading({ active: false, overlay: false });
                }
            });
        } else if (lastSearchQuery.current != query) {
            parkedSearch.current = () => {
                search(query);
            };
        }
    };

    return (
        <div>
            <SearchBox
                placeholder="Search..."
                value={inputValue}
                onChange={(e: any, newValue: string) => setInputValue(newValue)}
                onSearch={onSearch}
                // componentRef={searchFieldRef}
                // value={searchInputValue}
                // underlined={true}
                // onSelect={searchFor}
                // onChange={charsTyped}
                // onSearch={onsearch}
                // onFocus={searchFocus}
                // iconProps={filterIcon}
                // styles={searchBoxStyles}
                styles={{
                    root: {
                        ...(isTeams || isDarkmode ? { border: 'none' } : {}),
                        borderRadius: 4,
                    },
                }}
            />
        </div>
    );
};

const groupByProject = (allTasks: TimeSearchRow[]) => {
    const allProjects = [];

    allTasks.forEach(task => {
        const indexOfProject = allProjects.findIndex(project => project.projectId === task.projectId);

        if (indexOfProject == -1) {
            allProjects.push({
                projectId: task.projectId,
                projectName: task.projectName,
                tasks: [{ ...task }],
            });
        } else {
            allProjects[indexOfProject].tasks.push({ ...task });
        }
    });

    const sortedAllProjects = allProjects
        .map(project => ({
            ...project,
            tasks: [...project.tasks.sort((a: TimeSearchRow, b: TimeSearchRow) => (a.taskName > b.taskName ? 1 : -1))],
        }))
        .sort((a: any, b: any) => (a.projectName > b.projectName ? 1 : -1));

    return sortedAllProjects;
};
